import { setActiveEventId, shiftEvent } from 'modules/stream/store/overlay/overlay';
import { selectActiveEventId, selectEvents } from 'modules/stream/store/overlay/selectors';
import useLoadEventBase, { OverlayEventBindings } from 'modules/overlay-v2/ui/hooks/use-load-event';
import Static from 'ud-ui/components/fabric-canvas/canvases/static';

const streamBindings: OverlayEventBindings = {
  selectEvents,
  selectActiveEventId,
  setActiveEventId,
  shiftEvent,
};

interface IProps {
  manager: Static;
}

/** Проигрывание очереди событий на канвасе поверх слайса `state.overlay`. */
function useLoadEvent(props: IProps) {
  return useLoadEventBase({ manager: props.manager, bindings: streamBindings });
}

export default useLoadEvent;
